import React, { useState, useEffect } from 'react';
import { withRouter, NavLink, Link } from 'react-router-dom';
import moment from 'moment';

import Modal from '../../../../components/Modal';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import { config } from '../../../../config';
import { GET, newFetch, POST } from '../../../../helpers/fetch';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
const { SERVER_URL } = config;

const LogDetail = ({
  history,
  match: {
    params: { log_id },
  },
}) => {
  const [log, setLog] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [lastDayDate, setLastDayDate] = useState('');
  const [previewLastDayDate, setPreviewLastDayDate] = useState('');
  const [sendEmail, setSendEmail] = useState(false);
  const [activeModal, setActiveModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);

  const openInNewTab = (url) => {
    let win = window.open(url, '_blank');
    win.focus();
  };

  const handleShowModal = (action) => {
    setActiveModal(action);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setActiveModal(false);
    setShowModal(false);
    setShowPreviewModal(false);
  };

  const fetchLog = async (id) => {
    let api_path = `/performance_management/${id}`;
    let response = await newFetch(GET, api_path);

    response.success && setLog(response.data);
  };

  const handleApprove = async () => {
    if (log.action === 'Termination Letter' && !lastDayDate) {
      ToastUtil.error('Please input Last Day Date for the associate.');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to approve this performance log?'
      )
    ) {
      let data = {
        last_day_date: lastDayDate,
        remarks,
        flag: sendEmail,
      };

      let api_path = `/performance_management/approve/${log_id}`;
      let response = await newFetch(POST, api_path, data);

      if (response.success) {
        ToastUtil.success(response.message);
        setLastDayDate('');
        setRemarks('');
        setShowModal(false);
        fetchLog(log_id);
      }
    }
  };

  const handleReject = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to reject this performance log?'
      )
    ) {
      let data = {
        remarks,
      };

      let api_path = `/performance_management/reject/${log_id}`;
      let response = await newFetch(POST, api_path, data);

      if (response.success) {
        ToastUtil.success(response.message);
        setRemarks('');
        setShowModal(false);
        fetchLog(log_id);
      }
    }
  };

  const handleGenerateLetter = async () => {
    let data = {
      last_day_date: previewLastDayDate,
    };
    let api_path = `/performance_management/view_letter/${log_id}`;
    let response = await newFetch(POST, api_path, data);

    if (response.success) {
      await fetchLog(log_id);
      response.result && openInNewTab(`${SERVER_URL}/${response.result}`);
    }
  };

  const handlePreview = async () => {
    if (log.action === 'Termination Letter' && !previewLastDayDate) {
      ToastUtil.error('Please input Last Day Date to preview letter.');
      return false;
    }

    await handleGenerateLetter();
    setShowPreviewModal(false);
  };

  useEffect(() => {
    fetchLog(log_id);
  }, [log_id]);

  return (
    <>
      <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
        <div
          className="d-flex flex-column"
          style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
        >
          <NavLink
            to="/performance-management"
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div style={{ color: '#5156BE' }}>
              <i className="fas fa-chevron-left pe-2"></i> Back to Performance
              Management
            </div>
          </NavLink>
          <div className="d-flex justify-content-between pt-4">
            <h5>System Log: {log ? log.log_id : ''}</h5>
          </div>
        </div>
        <div
          className="d-flex"
          style={{ marginTop: '2rem', marginLeft: '3rem', marginRight: '3rem' }}
        >
          {log && (
            <>
              <div className="flex-grow-1">
                <div className="rounded shadow bg-white">
                  <div className="p-4 d-flex flex-column">
                    <div className="d-flex flex-row border-bottom pb-4">
                      <div className="d-flex flex-column">
                        <div className="text-muted">Client</div>
                        <div className="text-brand fw-bold">
                          {log.site.client.name}
                        </div>
                      </div>
                      <div className="d-flex flex-column mx-4">
                        <div className="text-muted">Site</div>
                        <div className="text-brand fw-bold">
                          {log.site.name}
                        </div>
                      </div>
                      <div className="flex-grow-1"></div>
                      <div className="d-flex flex-column">
                        <div className="text-muted text-end">Date Created</div>
                        <div>
                          {moment(log.createdAt, 'YYYY-MM-DD HH:mm:ss').format(
                            'DD MMM YYYY, hh:mma'
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column pt-4">
                      <div className="text-muted">Disciplinary</div>
                      <p className="pt-2">
                        {log.action ? log.action : 'No action'}
                      </p>
                    </div>
                    <div className="d-flex flex-column pt-4">
                      <div className="text-muted">Associate</div>
                      <div className="d-flex align-items-center mt-2 rounded y-2">
                        <div className="mx-2">
                          <img
                            className="img-responsive rounded-circle border"
                            src={
                              log.associate.image
                                ? `${SERVER_URL}/${log.associate.image}`
                                : placeholderImage
                            }
                            alt="username-img"
                            style={{ height: '35px', width: '35px' }}
                          />
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <Link
                            to={`/associates/associate/${log.associate.id}`}
                            style={{
                              color: 'inherit',
                              textDecoration: 'none',
                              cursor: 'pointer',
                            }}
                          >
                            <div
                              className={
                                !log.associate.active ? 'text-danger' : ''
                              }
                            >{`${log.associate.first_name} ${log.associate.last_name}`}</div>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column pt-4">
                      <div className="text-muted">Description</div>
                      <p className="pt-2">{log.description}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{
                  minWidth: '250px',
                  width: '250px',
                  marginLeft: '2rem',
                }}
              >
                <strong>Status</strong>
                <div className="mt-2">
                  <span
                    className={
                      'badge rounded-pill p-2 ' +
                      (log.status === 'Pending'
                        ? 'bg-warning'
                        : log.status === 'Approved'
                        ? 'bg-success'
                        : log.status === 'Rejected'
                        ? 'bg-danger'
                        : 'bg-default')
                    }
                  >
                    {log.status}
                  </span>
                </div>

                {log.status === 'Pending' && (
                  <>
                    <strong className="mt-4">Action</strong>
                    <div className="mt-2">
                      <button
                        className="btn btn-block btn-brand me-3 adjust-fs adjust-shadow"
                        onClick={() => handleShowModal('approve')}
                      >
                        Approve
                      </button>
                      <button
                        className="btn btn-block btn-outline-brand adjust-fs adjust-shadow"
                        onClick={() => handleShowModal('reject')}
                      >
                        Reject
                      </button>
                    </div>
                  </>
                )}

                {log.action !== 'Counselling' &&
                  log.action !== 'Verbal Warning' && (
                    <>
                      <strong className="mt-4">Letter Preview</strong>
                      <button
                        className="btn btn-block btn-outline-brand mt-2 adjust-fs adjust-shadow"
                        onClick={
                          // () => setShowPreviewModal(true)
                          () =>
                            log.status === 'Approved' && log.attachment
                              ? openInNewTab(`${SERVER_URL}/${log.attachment}`)
                              : setShowPreviewModal(true)
                        }
                      >
                        Preview
                      </button>
                    </>
                  )}

                <strong className="mt-4">Remarks</strong>
                <div className="mt-2">
                  {log.remarks ? log.remarks : 'No remarks'}
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <Modal showModal={showModal}>
        <div className="d-flex flex-column h-100">
          <h5>
            {activeModal &&
              activeModal.charAt(0).toUpperCase() + activeModal.slice(1)}{' '}
            Log
          </h5>
          <small>
            Disciplinary action will take effect once system log is approve and
            the respective associate will be notified.
          </small>
          {activeModal === 'approve' &&
            log &&
            log.action === 'Termination Letter' && (
              <>
                <strong className="mt-2">Last Day Date*</strong>
                <input
                  type="date"
                  className="form-control mt-2"
                  value={lastDayDate}
                  onChange={(e) => setLastDayDate(e.target.value)}
                />
              </>
            )}
          <textarea
            style={{ resize: 'none' }}
            rows="5"
            className="form-control mt-4"
            placeholder="Enter remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
          {activeModal === 'approve' &&
            log &&
            log.action !== 'Counselling' &&
            log.action !== 'Verbal Warning' && (
              <div className="d-flex align-items-center mt-3">
                <input
                  type="checkbox"
                  checked={sendEmail}
                  onChange={() => setSendEmail(!sendEmail)}
                />
                <div className="ms-2">Send Email?</div>
              </div>
            )}
          <div className="py-4 border-top d-flex justify-content-end mt-auto me-2">
            <button
              className="btn btn-outline-default"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              className="btn btn-brand"
              onClick={activeModal === 'approve' ? handleApprove : handleReject}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>
      <Modal showModal={showPreviewModal}>
        <div className="d-flex flex-column h-100">
          <h6>
            Preview{' '}
            {log && log.action.charAt(0).toUpperCase() + log.action.slice(1)}
          </h6>
          <small>Click confirm to generate and preview letter.</small>
          {log && log.action === 'Termination Letter' && log.type !== 4 && (
            <>
              <strong className="mt-4 text-muted">Last Day Date</strong>
              <input
                type="date"
                className="form-control mt-2"
                value={previewLastDayDate}
                onChange={(e) => setPreviewLastDayDate(e.target.value)}
              />
            </>
          )}
          <div className="py-4 border-top d-flex justify-content-end mt-auto me-2">
            <button
              className="btn btn-outline-default me-2 adjust-fs adjust-shadow"
              onClick={handleCloseModal}
            >
              Cancel
            </button>
            <button
              className="btn btn-brand adjust-fs adjust-shadow"
              onClick={handlePreview}
            >
              Confirm
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default withRouter(LogDetail);
